/**
 * Detection del env productivo client-side.
 *
 * El SPA es un único build estático servido en dos hostnames:
 *   - donutsuniverse.cloud         → prod
 *   - staging.donutsuniverse.cloud → staging
 *
 * Detect via window.location.hostname permite mantener un solo
 * bundle (R-003 del research de feature 004). SSR-safe: retorna
 * "local" si window no está disponible.
 */
export type Env = "prod" | "staging" | "local";

export function detectEnv(): Env {
  if (typeof window === "undefined") return "local";
  const host = window.location.hostname.toLowerCase();
  if (host === "donutsuniverse.cloud") return "prod";
  if (host === "staging.donutsuniverse.cloud") return "staging";
  return "local";
}

/**
 * Devuelve la URL base del backend según el env detectado.
 *
 * Las VITE_* se inyectan en build-time desde el workflow de despliegue.
 */
export function apiBase(): string {
  switch (detectEnv()) {
    case "prod":
      return import.meta.env.VITE_API_BASE_PROD ?? "";
    case "staging":
      return import.meta.env.VITE_API_BASE_STAGING ?? "";
    default:
      // "local" incluye los dominios `*.web.app` de Firebase, que es por
      // donde se verifica el despliegue ANTES de mover el DNS. Sin este
      // respaldo, ahí `apiBase()` devolvería "" y cada fetch iría contra
      // Firebase Hosting, que responde el index.html con HTTP 200 — un
      // fallo mudo y muy confuso de diagnosticar.
      //
      // En desarrollo local la variable no está definida y se devuelve ""
      // como siempre, para que funcione el proxy de vite.
      return import.meta.env.VITE_API_BASE_URL ?? "";
  }
}
